import api from './api';

/*
 * M:N доступ пользователей к объектам иерархии (ТЗ №23).
 * entityType: factory | workshop | section | room | camera.
 * Удаление: include_descendants=true снимает доступ и со всех вложенных объектов.
 */

export const listAccessGrants = (entityType, entityId) =>
  api.get(`/admin/access-grants/${entityType}/${entityId}`).then((response) => response.data);

export const grantAccess = (entityType, entityId, userIds, includeDescendants = false) =>
  api
    .post(`/admin/access-grants/${entityType}/${entityId}`, {
      user_ids: userIds,
      include_descendants: Boolean(includeDescendants),
    })
    .then((response) => response.data);

export const revokeAccess = (entityType, entityId, userId, includeDescendants = false) =>
  api
    .delete(`/admin/access-grants/${entityType}/${entityId}/${userId}`, {
      params: { include_descendants: Boolean(includeDescendants) },
    })
    .then((response) => response.data);
